import { ActionTypes } from "../actions/Schedule";

function schedule(state = {}, action = {}) {
    switch (action.type) {
        case ActionTypes.UPDATE_SELECTED_CHANNEL:
            return { ...state, currentChannelId: action.channelId };
        case ActionTypes.UPDATE_SCHEDULE_STARTED:
            return { ...state, isFetching: true };
        case ActionTypes.UPDATE_SCHEDULE_SUCCESS:
            // eslint-disable-next-line no-case-declarations
            const allSchedules = { ...state.allSchedules, ...action.data };
            return { ...state, allSchedules, isFetching: false };
        case ActionTypes.UPDATE_SCHEDULE_FAILED:
            return { ...state, isFetching: false };
        default:
            return state;
    }
}

export default schedule;
